import { render, staticRenderFns } from "./editTaskDialog.vue?vue&type=template&id=9fb8c860&scoped=true"
import script from "./editTaskDialog.vue?vue&type=script&lang=js"
export * from "./editTaskDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb8c860",
  null
  
)

export default component.exports